import React from "react";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Tooltip,
  Text,
  Label,
  Cell
} from "recharts";
import Teams, { UNMET_DEMAND_COLOR } from "../../../../../api/Teams";

function renderLabel(props) {
  const percent = (props.percent * 100).toFixed(0);

  return (
    <Text
      {...props}
      alignmentBaseline="middle"
      className="recharts-pie-label-text"
    >
      {`${percent}%`}
    </Text>
  );
}

function formatMillions(val) {
  let valStr = (val / 1000000).toFixed(2);
  return `${valStr}M`;
}

function MarketCaptureChart(props) {
  const colors = Teams.competitiveColors();
  let unmetDemand = props.totalDemand;
  const data = props.data.map(item => {
    const { team, value } = item;
    unmetDemand -= value;
    return {
      name: team,
      value
    };
  });

  data.push({
    name: "Unmet Demand",
    value: unmetDemand
  });

  const teams_count = data.length - 1;

  return (
    <div className="donut-chart donut-chart-us">
      <ResponsiveContainer width="100%" height={235}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={80}
            fill="#8884d8"
            label={renderLabel}
            labelLine={true}
          >
            <Label
              position="center"
              value={`Total Demand: ${formatMillions(props.totalDemand)}`}
            />
            {colors.slice(0, teams_count).map((color, i) => (
              <Cell key={i} fill={color} />
            ))}
            <Cell fill={UNMET_DEMAND_COLOR} />
          </Pie>
          <Tooltip formatter={formatMillions} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

export default MarketCaptureChart;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/charts/market-capture.js